// src/components/tutorials/JS_Array_Reference.js
import React from "react";
import "../../../AllComponentCSS.css";

export default function JS_Array_Reference() {
  const arrayMethods = [
    { name: "new Array()", desc: "Creates a new Array" },
    { name: "at()", desc: "Returns an indexed element of an array" },
    {
      name: "concat()",
      desc: "Joins arrays and returns an array with the joined arrays",
    },
    {
      name: "constructor",
      desc: "Returns the function that created the Array prototype",
    },
    {
      name: "copyWithin()",
      desc: "Copies array elements within the array, to and from specified positions",
    },
    {
      name: "entries()",
      desc: "Returns a key/value pair Array Iteration Object",
    },
    {
      name: "every()",
      desc: "Checks if every element in an array pass a test",
    },
    {
      name: "fill()",
      desc: "Fill the elements in an array with a static value",
    },
    {
      name: "filter()",
      desc: "Creates a new array with every element in an array that pass a test",
    },
    {
      name: "find()",
      desc: "Returns the value of the first element in an array that pass a test",
    },
    {
      name: "findIndex()",
      desc: "Returns the index of the first element in an array that pass a test",
    },
    {
      name: "findLast()",
      desc: "Returns the value of the last element in an array that pass a test",
    },
    {
      name: "findLastIndex()",
      desc: "Returns the index of the last element in an array that pass a test",
    },
    { name: "flat()", desc: "Concatenates sub-array elements" },
    {
      name: "flatMap()",
      desc: "Maps all array elements and creates a new flat array",
    },
    { name: "forEach()", desc: "Calls a function for each array element" },
    { name: "from()", desc: "Creates an array from an object" },
    {
      name: "includes()",
      desc: "Check if an array contains the specified element",
    },
    {
      name: "indexOf()",
      desc: "Search the array for an element and returns its position",
    },
    { name: "isArray()", desc: "Checks whether an object is an array" },
    { name: "join()", desc: "Joins all elements of an array into a string" },
    {
      name: "keys()",
      desc: "Returns a Array Iteration Object, containing the keys of the original array",
    },
    {
      name: "lastIndexOf()",
      desc: "Search the array for an element, starting at the end, and returns its position",
    },
    {
      name: "length",
      desc: "Sets or returns the number of elements in an array",
    },
    {
      name: "map()",
      desc: "Creates a new array with the result of calling a function for each array element",
    },
    { name: "of()", desc: "Creates an array from a number of arguments" },
    {
      name: "pop()",
      desc: "Removes the last element of an array, and returns that element",
    },
    {
      name: "prototype",
      desc: "Allows you to add properties and methods to an Array object",
    },
    {
      name: "push()",
      desc: "Adds new elements to the end of an array, and returns the new length",
    },
    {
      name: "reduce()",
      desc: "Reduce the values of an array to a single value (going left-to-right)",
    },
    {
      name: "reduceRight()",
      desc: "Reduce the values of an array to a single value (going right-to-left)",
    },
    {
      name: "reverse()",
      desc: "Reverses the order of the elements in an array",
    },
    {
      name: "shift()",
      desc: "Removes the first element of an array, and returns that element",
    },
    {
      name: "slice()",
      desc: "Selects a part of an array, and returns the new array",
    },
    {
      name: "some()",
      desc: "Checks if any of the elements in an array pass a test",
    },
    { name: "sort()", desc: "Sorts the elements of an array" },
    { name: "splice()", desc: "Adds or Removes array elements" },
    {
      name: "toReversed()",
      desc: "Reverses the order of array elements (to a new array)",
    },
    {
      name: "toSorted()",
      desc: "Sorts the elements of an array (to a new array)",
    },
    {
      name: "toSpliced()",
      desc: "Adds or Removes array elements (to a new array)",
    },
    {
      name: "toString()",
      desc: "Converts an array to a string, and returns the result",
    },
    {
      name: "unshift()",
      desc: "Adds new elements to the beginning of an array, and returns the new length",
    },
    { name: "valueOf()", desc: "Returns the primitive value of an array" },
    { name: "with()", desc: "Returns a new array with updated elements" },
  ];

  return (
    <div className="tutorial-container">
      <h1 className="tutorial-title">Complete Array Reference</h1>
      <p className="tutorial-intro">Revised July 2025</p>

      <div
        className="Key_point_container"
        style={{
          background: "linear-gradient(135deg, #fef9c3, #fde68a)",
          color: "#000",
          borderRadius: "12px",
          padding: "1rem 1.5rem",
        }}
      >
        <h2
          style={{ color: "#78350f", fontSize: "2rem", marginBottom: "0.5rem" }}
        >
          JavaScript Array Method Reference Table
        </h2>
        <p style={{ fontSize: "1.1rem", margin: 0 }}>
          A complete list of Array properties and methods available in modern
          JavaScript.
        </p>
      </div>

      <div
        className="reference-table-container"
        style={{
          marginTop: "1.5rem",
          overflowX: "auto",
          borderRadius: "10px",
          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
        }}
      >
        <table
          className="reference-table"
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "1rem",
            backgroundColor: "#fff",
          }}
        >
          <thead style={{ background: "#0d9488", color: "white" }}>
            <tr>
              <th
                style={{
                  textAlign: "left",
                  padding: "0.8rem 1rem",
                  width: "25%",
                }}
              >
                Name
              </th>
              <th style={{ textAlign: "left", padding: "0.8rem 1rem" }}>
                Description
              </th>
            </tr>
          </thead>
          <tbody>
            {arrayMethods.map((item, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#f9fafb" : "#fff",
                  borderBottom: "1px solid #e5e7eb",
                }}
              >
                <td
                  style={{
                    padding: "0.7rem 1rem",
                    fontFamily: "monospace",
                    fontWeight: "bold",
                    color: "#2563eb",
                  }}
                >
                  {item.name}
                </td>
                <td style={{ padding: "0.7rem 1rem" }}>{item.desc}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
